import { SourceValues } from './../../shared/createattribute.model';
import { AuthenticationService } from '../../shared/authentication.service';
import { LocalStorage } from '../../shared/localstorage.service';
import { GCAttributeValue, AttributeNameValues } from '../../shared/createattribute.model';

import { CreateAttributeService } from '../../shared/createattribute.service';
import { ConfirmdialogComponent } from './../../dialogs/confirmdialog/confirmdialog.component';
import { CreateAttributeDialogComponent } from './../create-attribute-dialog/create-attribute-dialog.component';
import { Component, OnInit, Inject, Directive } from '@angular/core';
import { AttributeNames } from '../../shared/createattribute.model';
import { TicketTypes, ticketType } from '../../shared/ticket-types.model';
import { MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material';


@Component({
  selector: 'app-create-package-attributes',
  templateUrl: './create-package-attributes.component.html',
  styleUrls: ['./create-package-attributes.component.scss']
})
export class CreatePackageAttributesComponent implements OnInit {

  loading = false;
  screen = false;
  packetAttributes: AttributeNames[];
  attributeValues: AttributeNameValues[];
  tickettypes: ticketType[];
  sourceValues = new Array<SourceValues>();
  attribute: number;
  UpdateTarget: HTMLElement;
  ValuesTarget: HTMLElement;
  source: any;
  MovingAttribute: SourceValues;
  UpdateAttribute = new Array<SourceValues>();
  SaveUpdatedAttributes = new Array<SourceValues>();
  attributeNameId: number;
  selectedAttribute: AttributeNames;
  savedAttributes: AttributeNameValues[];
  existingAttributes: AttributeNameValues[];
  ticketSources: string[];
  addText = false;
  addFreeText: string = "";

  constructor(
    public dialog: MatDialog,
    public service: CreateAttributeService,
    private localstorage: LocalStorage,
    public auth: AuthenticationService,
    public snackBar: MatSnackBar) {

  }

  ngOnInit() {
    this.service.getQualityAttributes(this.auth.currentState).subscribe((res: AttributeNames[]) => {
      
      this.packetAttributes = res;
    });
  }

  DragEnter($event) {
    this.UpdateTarget = document.getElementById('Update');
    this.ValuesTarget = document.getElementById('Values');
    if (($event.target === this.ValuesTarget.parentNode
      || $event.target === this.ValuesTarget
      || $event.target.parentNode === this.ValuesTarget)
      && this.UpdateAttribute.findIndex(x => x.ViewValue === this.MovingAttribute.ViewValue) === -1) {
      this.UpdateAttribute.push(this.MovingAttribute);
      this.SaveUpdatedAttributes.push(this.MovingAttribute);
    }
  }

  DragStart($event, value) {
    this.source = $event.target;
    this.MovingAttribute = value;
    $event.dataTransfer.effectAllowed = 'move';
  }

  openDialog() {

    let dialogRef = this.dialog.open(CreateAttributeDialogComponent, {
      width: '600px',
      data: 'This is text'
    });
  }

  onSelectClick(qualityAttributeId: number, qualityAttributeName: string, qualityAttributeTypeId: number) {
    this.addText = false;
    this.screen = true;
    this.sourceValues = [];
    this.UpdateAttribute = [];
    this.SaveUpdatedAttributes = [];
    this.attributeNameId = qualityAttributeId;
    if (qualityAttributeTypeId === 1) {
      if (qualityAttributeName === 'TicketType') {
        this.screen = true;
        this.service.getQualityAttributeId(qualityAttributeName, this.auth.currentState).subscribe((res => {
          this.selectedAttribute = res;
          this.attributeNameId = this.selectedAttribute.ID;
          this.service.getQualityAttributeValues(this.attributeNameId, this.auth.currentState).subscribe(res => {
            this.existingAttributes = res;
            var count = 0;
            for (let existingAttribute of this.existingAttributes) {
              count++;
              this.UpdateAttribute.push({ Value: count, ViewValue: existingAttribute.GCAttributeValueName });
            }
          });

          this.service.getTicketTypes(this.localstorage.getItem('token'), this.localstorage.getItem('currentState')).subscribe((res: TicketTypes[]) => {
            this.tickettypes = res['ticketType'];
            var count = 0;
            for (let tickettype of this.tickettypes) {
              count++;
              this.sourceValues.push({ Value: count, ViewValue: tickettype.key });
              this.screen = false;
            }
            this.screen = false;
          });
        }
        ));
      }
      else if (qualityAttributeName === 'Source') {
        this.screen = true;
        this.service.getQualityAttributeValues(qualityAttributeId, this.auth.currentState).subscribe(res => {
          this.existingAttributes = res;
          var count = 0;
          for (let existingAttribute of this.existingAttributes) {
            count++;
            this.UpdateAttribute.push({ Value: count, ViewValue: existingAttribute.GCAttributeValueName });
          }
        });
        this.service.getTicketSources( this.localstorage.getItem('currentState')).subscribe((res) => {
          this.ticketSources = res;
          var count = 0;
          for (let attributevalue of this.ticketSources) {
            count++;
            this.sourceValues.push({ Value: count, ViewValue: attributevalue });
            this.screen = false;
          }
          this.screen = false;
        });
        this.sourceValues = [];
      }
      else {
        this.addText = true;
        this.screen = true;
        this.service.getQualityAttributeValues(qualityAttributeId, this.auth.currentState).subscribe(res => {
          this.existingAttributes = res;
          var count = 0;
          for (let existingAttribute of this.existingAttributes) {
            count++;
            this.UpdateAttribute.push({ Value: count, ViewValue: existingAttribute.GCAttributeValueName });
            this.screen = false;
          }
        this.screen = false;
        });
      }
    }
    else {
      this.addText = true;
      this.screen = true;
      this.service.getQualityAttributeValues(qualityAttributeId, this.auth.currentState).subscribe(res => {
        this.existingAttributes = res;
        var count = 0;
        for (let existingAttribute of this.existingAttributes) {
          count++;
          this.UpdateAttribute.push({ Value: count, ViewValue: existingAttribute.GCAttributeValueName });
          this.screen = false;
        }
        this.screen = false;
      });
    }
  }

  addAttribute() {
    var NewSourceValue = new SourceValues();
    NewSourceValue.ViewValue = this.addFreeText;
    this.UpdateAttribute.push(NewSourceValue);
    this.SaveUpdatedAttributes.push(NewSourceValue);
    this.addFreeText = "";
  }

  saveAttributes() {
    let dialogRef = this.dialog.open(ConfirmdialogComponent, {
      width: '600px',
      data: {
        title: 'Save Packet Attribute',
        content: 'Are you sure?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 'Cancel') {
        this.screen = true;
        for (let i = 0; i < this.SaveUpdatedAttributes.length; i++) {
          var attributeValueObj = new GCAttributeValue(this.attributeNameId, this.SaveUpdatedAttributes[i].ViewValue);
          this.service.createQualityAttributeValues(attributeValueObj, this.auth.currentState).subscribe(res => {
            this.screen = false;
            this.showSnackbarMessage('Packet Attributes Saved.');
          });
        }
      }
    });
  }

  deleteAttributes(name: string) {
    let dialogRef = this.dialog.open(ConfirmdialogComponent, {
      width: '600px',
      data: {
        title: 'Delete Packet Attribute',
        content: 'Are you sure?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 'Cancel') {
        this.screen = true;
        this.service.deleteQualityAttributeValues(this.attributeNameId, name, this.auth.currentState).subscribe(res => {
          this.UpdateAttribute.splice(this.UpdateAttribute.findIndex(x => x.ViewValue === name), 1);
          this.screen = false;
          this.showSnackbarMessage('Packet Attributes Deleted.');
        });
      }
    });
  }

  showSnackbarMessage(message: string) {
    this.snackBar.open(message, '', {
      duration: 2000
    });
  }
}